import React from 'react';
import {
  Alert,
  Box,
  Button,
  Typography
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import GenericModal from '../GenericModal';
import SecaoComprasDrillDownContent from './SecaoComprasDrillDownContent';
import { SecaoComprasDrillDownModalProps } from '../../types/secaoComprasDrillDown';
import { ProductDrillDownSkeleton } from '../Skeletons/ModalSkeletons';

const SecaoComprasDrillDownModal: React.FC<SecaoComprasDrillDownModalProps> = ({
  isOpen,
  onClose,
  data,
  loading,
  selectedSecao,
  error,
  onRetry
}) => {
  // Renderizar conteúdo baseado no estado
  const renderContent = () => {

    if (error) {
      return (
        <Box sx={{ p: 3 }}>
          <Alert 
            severity="error" 
            action={
              onRetry && (
                <Button
                  color="inherit"
                  size="small"
                  onClick={onRetry}
                  startIcon={<RefreshIcon />}
                >
                  Tentar Novamente
                </Button>
              )
            }
          >
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>Erro ao carregar dados:</strong>
            </Typography>
            <Typography variant="body2">
              {error}
            </Typography>
          </Alert>
        </Box>
      );
    }

    if (!data) {
      return (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 300,
            flexDirection: 'column',
            gap: 2
          }}
        >
          <Typography variant="h6" color="text.secondary">
            📊 Nenhum dado disponível
          </Typography>
          <Typography variant="body2" color="text.secondary" textAlign="center">
            Não foram encontrados dados para esta seção.<br/>
            Verifique se a seção possui compras registradas.
          </Typography>
          {onRetry && (
            <Button
              variant="outlined"
              onClick={onRetry}
              startIcon={<RefreshIcon />}
              size="small"
            >
              Recarregar Dados
            </Button>
          )}
        </Box>
      );
    }

    return <SecaoComprasDrillDownContent data={data} />;
  };

  return (
    <GenericModal
      open={isOpen}
      onClose={onClose}
      title={
        selectedSecao 
          ? `🛒 Análise Detalhada: ${selectedSecao.nome}` 
          : 'Detalhes da Seção de Compras'
      }
      loading={false}
      maxWidth="xl"
      fullWidth
    >
      {loading ? (
        <ProductDrillDownSkeleton />
      ) : (
        renderContent()
      )}
    </GenericModal>
  );
};

export default SecaoComprasDrillDownModal; 